import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, SMALL_MARGIN, MIDDLE_MARGIN, LARGE_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        padding: `${MIDDLE_MARGIN}px 0`,
        background: theme.palette.secondary.dark,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          padding: `${LARGE_MARGIN}px 0`,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
      },
      content: {
        [theme.breakpoints.up('md')]: {
          width: '50%',
          minWidth: '50%',
          paddingRight: MIDDLE_MARGIN,
        },
        [theme.breakpoints.up('lg')]: {
          paddingRight: LARGE_MARGIN,
        },
      },
      contentWrap: {
        position: 'relative',
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          alignItems: 'center',
        },
      },
      button: {
        '&.button-desktop': {
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        '&.button-mobile': {
          display: 'flex',
          margin: 'auto',
          [theme.breakpoints.up('md')]: {
            display: 'none',
          },
          [theme.breakpoints.down('xs')]: {
            width: '100%',
          },
        },
      },
      heading: {
        marginBottom: SMALL_MARGIN,
        width: '100%',
        fontSize: 24,
        lineHeight: 1.2,
        [theme.breakpoints.up('md')]: {
          fontSize: 28,
          lineHeight: 1.4,
        },
      },
      description: {
        fontSize: 18,
        lineHeight: 1.5,
        color: colorsPalette.white,
        marginBottom: MIDDLE_MARGIN,
      },
      subheading: {
        fontSize: 20,
        lineHeight: 1.4,
        color: colorsPalette.white,
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: 24,
        },
      },
      tabs: {
        marginBottom: MIDDLE_MARGIN,
        padding: 0,
        listStyle: 'none',
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        },
      },
      tab: {
        color: colorsPalette.white,
        background: colorsPalette.blackSecondary,
        borderRadius: 8,
        transition: 'all, .3s',
        cursor: 'pointer',
        lineHeight: 1.4,
        fontSize: 14,
        textAlign: 'center',
        padding: '10px 16px',
        '&.active-tab': {
          background: colorsPalette.violet,
        },
        [theme.breakpoints.down('sm')]: {
          minWidth: 'calc(50% - 12px)',
          flex: 1,
          '&:nth-child(odd)': {
            marginRight: 24,
          },
          '&:nth-child(-n+2)': {
            marginBottom: 24,
          },
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'left',
          padding: SMALL_MARGIN,
          fontSize: 20,
          '&.active-tab': {
            marginLeft: SMALL_MARGIN,
          },
          '&:not(:last-child)': {
            marginBottom: SMALL_MARGIN,
          },
        },
        [theme.breakpoints.up('xl')]: {
          width: 460,
        },
      },
      imageList: {
        overflow: 'hidden',
        margin: `0 auto ${MIDDLE_MARGIN}px`,
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
          minWidth: '50vw',
          paddingRight: 20,
        },
        [theme.breakpoints.up('xl')]: {
          paddingRight: MIDDLE_MARGIN,
        },
      },
      mobileImage: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
        '&.active-img': {
          display: 'flex',
          justifyContent: 'center',
          [theme.breakpoints.up('md')]: {
            display: 'none',
          },
        },
        '& img': {
          maxHeight: 540,
          width: '100%',
          objectFit: 'contain',
        },
      },
      desktopImage: {
        display: 'none',
        transition: 'all .3s',
        width: '100%',
        '&.active-img': {
          [theme.breakpoints.up('md')]: {
            display: 'block',
          },
        },
        '& img': {
          width: '100%',
        },
      },
    }),
  );

export default useStyles;
